import { useCallback } from 'react';
import { useLingui } from '@lingui/react';
import { useFilterByPrimaryDimensionDeviceId, makeGetOSNameWithTranslation } from '../utils';
import { usePersonDeviceTransformApi } from './api';

export const usePersonDevicesOs = () => {
  const {
    _,
  } = useLingui();
  const transformFunction = useCallback(makeGetOSNameWithTranslation(_), [_]);
  const filterPredicate = useFilterByPrimaryDimensionDeviceId();
  const result = usePersonDeviceTransformApi({
    filterPredicate,
    transformFunction,
  });
  return result;
};
